import React, { useState, useEffect ,useRef } from "react";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink  , useParams} from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    backgroundColor:'#F2F4F6',
    minHeight: '100vh',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));


const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 600,
  width:'100%',
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundColor:'#fff',
  padding: theme.spacing(12,8),
  borderRadius:'30px',
  boxShadow: theme.customShadows.card,
}));

// ----------------------------------------------------------------------

export default function Failed() {
    const params = new URLSearchParams(window.location.search);
      const [message, setMessage] = useState('');
      const [code, setCode] = useState('');
    
    useEffect(() => {
        setMessage(params.get('message'));
        setCode(params.get('code'))
        // console.log(params.get('message'));
    }, [])
 
  return (
    <>
      <Helmet>
        <title> Login | RainDrop </title>
      </Helmet>

      <StyledRoot>


        <Container maxWidth="sm" style={{ display : 'flex',justifyContent: 'center'}}>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
          {message}<br/> 해당 문제가 지속되면 관리자에게 문의하세요.<br/>{code}
          </Typography>

          <Button to="/license" size="large" variant="contained" component={RouterLink}>
          돌아가기
          </Button>
        </StyledContent>
          
        </Container>
      </StyledRoot>
    </>
  );
}
